import TeamBusinessImage from "../../../assets/webp/business/team-business.webp"

export const BusinessMiddleImage = () => {
  return (
    <div className="relative mx-auto px-4 -mt-[16rem] mb-[-6rem] z-10 md:px-10 lg:px-10 xl:px-32">
      <div className="max-w-7xl mx-auto">
        <div className="relative rounded-2xl overflow-hidden shadow-2xl">
          <img
            src={TeamBusinessImage}
            alt="Business team meeting"
            className="w-full h-[400px] md:h-[500px] object-cover"
          />
        </div>
      </div>
    </div>
  );
};
